import { createSlice } from "@reduxjs/toolkit";
import { GetRequisitionNames } from "services/dropdown/dropdown.service";
import { toast } from 'react-toastify';

export const workOrderNameSlice = createSlice({
  name: "workOrderNames",
  initialState: {
    workOrderNameList: [],
    workOrderNamesLoading: false,
    workOrderNamesError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetRequisitionNames.pending, (state) => {
      // toast.success('Promise pending for work order name🤯');
      state.workOrderNamesLoading = true
    });

    builder.addCase(GetRequisitionNames.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved for work order name 👌');

      state.workOrderNameList = action.payload
      state.workOrderNamesLoading = false
      state.workOrderNamesError = null
    });

    builder.addCase(GetRequisitionNames.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected for work order name 😣')

      state.workOrderNamesLoading = false
      state.workOrderNamesError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export default workOrderNameSlice.reducer;
